// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"230":"6ca25a1c","386":"580cf256","430":"4152ef7a"}[chunkId] + ".chunk.css";
};